import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { AdministratorService } from 'app/administrator/administrator.service';
import * as _ from 'lodash';
import { setDateFieldsToUTC } from 'app/common/util/util';
import { GraphService } from './graph.service';
@Injectable({
  providedIn: 'root',
})
export class NewRequestService {
  public readonly _request$: BehaviorSubject<any> = new BehaviorSubject<any>({});

  private readonly _requestDetail$: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  private readonly tasAuditAssistManagerEmit$ = new Subject();

  private readonly _tasPPMDSigned$ : BehaviorSubject<any> = new BehaviorSubject<any>(false);
  tasAuditAssistManagerChange$ = this.tasAuditAssistManagerEmit$.asObservable();

  public regionsList: any[];

  constructor(private readonly administratorService: AdministratorService, private readonly graphService: GraphService) {}

  get request$(): any {
    return this._request$.value;
  }

  get requestForm$(): any {
    return this._request$.asObservable();
  }

  get tasPPMDSigned$(){
    return this._tasPPMDSigned$.asObservable();
  }

  hasPPMDSigned(value: boolean){
    this._tasPPMDSigned$.next(value);
  }

  tasAuditAssistManagerChanged(value: string): void {
    this.tasAuditAssistManagerEmit$.next(value);
  }

  saveRequestForm(data: any): void {
    const currentValue = this._request$.value;
    this._request$.next({ ...currentValue, ...data });
  }

  setRequest(data: any): void {
    this._request$.next(data);
  }

  getRquestFormValidity(data): boolean {
    return (
      !!data.clientFormValidity &&
      data.clientFormValidity &&
      !!data.auditTeamFormValidity &&
      data.auditTeamFormValidity &&
      !!data.teamFormValidity &&
      data.teamFormValidity &&
      !!data.requestDetailsFormValidity &&
      data.requestDetailsFormValidity &&
      !!data.impDatesFormValidity &&
      data.impDatesFormValidity &&
      !!data.clientDetailFormValidity &&
      data.clientDetailFormValidity
    );
  }

  getFormValidityMessage(data): string {
    let msg = '';
    if (!(!!data.clientFormValidity && data.clientFormValidity)) {
      msg = msg + '\n-Client Information';
    }
    if (!(!!data.clientDetailFormValidity && data.clientDetailFormValidity)) {
      msg = msg + '\n-Client Detail';
    }
    if (!(!!data.auditTeamFormValidity && data.auditTeamFormValidity)) {
      msg = msg + '\n-Audit Team Information';
    }
    if (!(!!data.teamFormValidity || data.teamFormValidity)) {
      msg = msg + '\n-EY specialist Audit Assist Team Information';
    }
    if (!(!!data.requestDetailsFormValidity && data.requestDetailsFormValidity)) {
      msg = msg + '\n-Request Details';
    }
    if (!(!!data.impDatesFormValidity && data.impDatesFormValidity)) {
      msg = msg + '\n-Important Dates';
    }
    return msg;
  }

  // On Submit Request Form

  setReqestIdAfterCreation(data: any) {
    if (!!data) {
      this.saveRequestForm({
        requestId: !!data && data.RequestID ? data.RequestID : null,
      });
    }
  }

  // Request Detail section

  get requestDetail$(): Observable<any[]> {
    return this._requestDetail$.asObservable();
  }

  setRequestDetail(data: any): void {
    this._requestDetail$.next(data);
  }

  saveBulkRequestDetails(data: any): void {
    const currentValue = this._requestDetail$.value;
    let keyExist = false;

    let requestDetailsValue =
      !!currentValue.length &&
      currentValue.reduce((acc, value) => {
        if (value.TempRequestDetailId.toString() === data.TempRequestDetailId.toString()) {
          acc.push({ ...value, ...data });
          keyExist = true;
        } else {
          acc.push(value);
        }
        return acc;
      }, []);

    this._requestDetail$.next(requestDetailsValue);
  }

  removeRequestDetail(requestDetailID: Number) {
    const currentValue = this._requestDetail$.value;
    let requestDetail: any;
    requestDetail = currentValue.filter((x) => x.RequestDetailID !== requestDetailID);

    this._requestDetail$.next(requestDetail);
  }

  GetRequestDetailById(requestDetailID: any): any {
    const requestDetailsList = this._requestDetail$.value;

    return requestDetailsList.filter((x) => x.RequestDetailID === requestDetailID);
  }

  setRequestDetailWithRequestID() {
    const currentValue = this._requestDetail$.value;

    let requestDetailsValue =
      !!currentValue.length &&
      currentValue.reduce((acc, value) => {
        acc.push({ ...value, RequestID: this.request$.requestId, ClientID: this.request$.clientId });
        return acc;
      }, []);

    this._requestDetail$.next(requestDetailsValue);
  }

  setDataAfterSaveAll(result: any) {
    const currentValue = this._requestDetail$.value;
    let requestDetailsValue =
      !!currentValue.length &&
      currentValue.reduce((acc, value) => {
        const newValue = result.filter((x) => x.AnalysisType === value.AnalysisType && x.Active)[0];
        if (!!newValue) {
          if (!!value.Status && value.Status.toLowerCase() === 'not submitted') {
            acc.push({ ...value, ...newValue, TempStatus: newValue.Status });
          } else {
            acc.push({ ...value });
          }
        } else {
          acc.push({ ...value });
        }
        return acc;
      }, []);

    this._requestDetail$.next(requestDetailsValue);
  }


  async saveRequestToDB(saveAll: boolean = false) {
    let requestToSave = _.cloneDeep(this.request$);
    setDateFieldsToUTC(requestToSave);
    const result = await this.administratorService.insertData(
      JSON.stringify(btoa(encodeURIComponent(JSON.stringify([requestToSave])))),
      'DimRequests'
    );

    !!result && this.setReqestIdAfterCreation(result[0]);

    return result;
  }

  async SaveAnalysisDetail(
    requestDetailID: any,
    saveAll: boolean = false,
    listName: string = 'DimRequestDetails',
    isSubmit = false,
    isComplete = false
  ): Promise<any> {
    const result = await this.saveRequestToDB(saveAll);

    if (!!result) {
      return await this.save(requestDetailID, saveAll, listName, isSubmit, isComplete);
    }
  }

  async save(requestDetailID: any, saveAll: boolean = false, listName, isSubmit, isComplete = false): Promise<any> {
    let result = [{}];
    this.setRequestDetailWithRequestID();

    const detailInfo = saveAll ? this._requestDetail$.value : this.GetRequestDetailById(requestDetailID);
    let requistDetailInfo = _.cloneDeep(detailInfo);

    if (saveAll && !isSubmit) {
      requistDetailInfo = requistDetailInfo.filter((x) => x.AnalysisType !== '' && x.AnalysisType !== undefined);
    }

    // Sumit all case we need to consider only valid Request details and not in progress
    if (saveAll && isSubmit) {
      requistDetailInfo = requistDetailInfo.filter(
        (x) => x.DetailsFromAuditTeamComponentValidity && x.Status.toLowerCase() === 'not submitted'
      );
    }

    requistDetailInfo.map((value) => {
      setDateFieldsToUTC(value);
      if (!isSubmit) {
        value.Status = value.TempStatus;
        value.IsWorkpaperReminderSent = !!value.TempIsWorkpaperReminderSent ? value.TempIsWorkpaperReminderSent : false;
        if (isComplete) {
          value.IsComplete = true;
        }
      } else {
        if (this.GetTasAuditAssistManagersIdentified() !== null && this.GetHasAlreadyWorked()) {
          let PPMDs = this.GetTasAuditAssistPPMD();
          value.TASAuditAssistManager = this.GetTasAuditAssistManagersIdentified();
          if(PPMDs && JSON.parse(PPMDs).length > 1){
            value.TASAuditAssistExec = JSON.stringify(JSON.parse(PPMDs).slice(0 , JSON.parse(PPMDs).length -1));
            value.TAS2ndExec = JSON.stringify(JSON.parse(PPMDs).slice(JSON.parse(PPMDs).length -1 , JSON.parse(PPMDs).length));
          }
          if(PPMDs && JSON.parse(PPMDs).length == 1){
            value.TASAuditAssistExec = this.GetTasAuditAssistPPMD();
          }
          value.Status = 'Needs assignment';
          value.TASProjectManagerAssigned = new Date();
        } else {
          value.TASAuditAssistManager = '';
          value.TASAuditAssistExec = '';
          value.TAS2ndExec = '';
          value.Status = 'Needs assignment';
        }

        value.StaffingAdmin = '';
        value.SubmitAll = saveAll;
      }
    });

    // Setting TempRequestDetailId which can is used by Track by function
    if (!!requistDetailInfo) {
      result = await this.administratorService.insertData(
        JSON.stringify(btoa(encodeURIComponent(JSON.stringify(requistDetailInfo)))),
        listName
      );
    }

    return result;
  }

  IsCurrUserInString(mgrString) {
    if (mgrString === null || mgrString === '') {
      return false;
    }
    const mgrObjects = JSON.parse(mgrString);
    const currUser = this.graphService.currentUserData.UserEmail;
    const mgrMatch = !!mgrObjects ? mgrObjects.filter((x) => x.mail.toLowerCase() === currUser.toLowerCase()) : null;
    return !!mgrMatch && mgrMatch.length;
  }

  GetTasAuditAssistManagersIdentified() {
    return this.request$.TasAuditAssistManagersIdentified;
  }

  GetHasAlreadyWorked() {
    return this.request$.hasAlreadyWorked;
  }

  GetTasAuditAssistPPMD() {
    return this.request$.tasAuditAssistPPMD;
  }

  GetClientName() {
    return this.request$.clientName;
  }
}
